import { Injectable } from "@angular/core";

@Injectable()
export class ChartService
{
    protected readonly chartColors = [
        "#008F8C",
        "#0D2644",
        "#E36039",
        "#245718",
        "#5C6E83",
        "#641313",
        "#908939",
        "#5C4170",
        "#C63D3D",
        "#003D3C",
        "#006664",
        "#071322",
        "#D6491F",
        "#1A4012",
        "#4C5B6B",
        "#450D0D",
        "#756F2F",
        "#4A345B",
        "#AE3232",
        "#001414",
    ];

    getColors(count: number): Array<string>
    {
        const gcLength = this.chartColors.length;
        if (count <= gcLength)
        {
            return this.chartColors.slice(0, count);
        }
        const randomColors = [];
        for (let i = 0; i < count - gcLength; i++)
        {
            randomColors.push(this.randomRgb());
        }
        return this.chartColors.concat(randomColors);
    }

    private rand(): number
    {
        return Math.floor(Math.random() * 256);
    }

    private randomRgb(): string
    {
        return `rgb(${this.rand()},${this.rand()},${this.rand()})`;
    }
}
